import React, { Suspense } from 'react';
import { Switch } from 'react-router-dom';

import Route from 'routes/Route';
import Details from './Details';
import Invalid from './Invalid';

const Content = () => {
    return (
        <Suspense fallback={<div />}>
            <Switch>
                <Route
                    isPublic
                    path="/public/content/details/:category/:type/:id"
                    render={props => <Details {...props} />}
                />
                <Route
                    isPublic
                    path="/public/content/invalid"
                    render={props => <Invalid {...props} />}
                />
            </Switch>
        </Suspense>
    );
};

export default Content;
